import { LoggingService } from './logging.service';
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private loggingService: LoggingService) {
        super();
    }

    handleError(error: Error) {
        this.loggingService.logException(error); // Manually log exception
        super.handleError(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/error-handler.service.ts